export default __webpack_public_path__ + "static/media/köide-13-14.ff0ffb1d.png";